// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interventionSelectorItem{display:flex;flex-direction:column;justify-content:center;align-items:center}#impacts-images-container{width:60%}@media only screen and (min-device-width:320px) and (max-device-width:480px){#impacts-images-container{width:100%}}", ""]);
// Exports
module.exports = exports;
